import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

type EntryDirection = "left" | "right" | "top" | "bottom";
type GlowVariant = "blue" | "purple" | "emerald";

type AnimatedDivProps = {
  children: React.ReactNode;
  className?: string;
  entryFrom?: EntryDirection;
  glow?: GlowVariant;
  delay?: number;
};

const entryMap: Record<
  EntryDirection,
  { x?: number; y?: number; rotateY?: number }
> = {
  left: { x: -50, rotateY: -15 },
  right: { x: 50, rotateY: 15 },
  top: { y: -40 },
  bottom: { y: 40 },
};

const glowMap: Record<GlowVariant, string> = {
  blue: "from-blue-200/20 to-blue-600/20",
  purple: "from-purple-500/20 to-pink-500/20",
  emerald: "from-emerald-500/20 to-teal-500/20",
};

const AnimatedDiv = ({
  children,
  className,
  entryFrom = "right",
  glow = "blue",
  delay = 0,
}: AnimatedDivProps) => {
  const entry = entryMap[entryFrom];

  return (
    <motion.div
      initial={{
        opacity: 0,
        x: entry?.x ?? 0,
        y: entry?.y ?? 0,
        rotateY: entry?.rotateY ?? 0,
      }}
      animate={{
        opacity: 1,
        x: 0,
        y: 0,
        rotateY: 0,
      }}
      transition={{ duration: 0.7, delay }}
      whileHover={{
        scale: 1.02,
        y: -8,
        rotateX: 2,
        boxShadow: "0 30px 60px -15px rgba(0,0,0,0.25)",
      }}
      style={{ transformStyle: "preserve-3d" }}
      className={cn(
        `
        group
        relative
        overflow-hidden
        rounded-3xl
        bg-gradient-to-br
        from-slate-50
        to-slate-100/50
        p-8
        shadow-xl
        border
        border-slate-200/50
        `,
        className,
      )}
    >
      {/* Glow (COM blur – correto) */}
      <div
        className={cn(
          `
          pointer-events-none
          absolute
          -top-40 -right-40
          w-80 h-80
          rounded-full
          opacity-0
          group-hover:opacity-100
          transition-opacity
          duration-1000
          bg-gradient-to-br
          blur-3xl
          `,
          glowMap[glow],
        )}
      />

      {/* Conteúdo (SEM blur) */}
      <div className="relative z-10">{children}</div>
    </motion.div>
  );
};

export default AnimatedDiv;
